import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { getReadyUrls } from './imagePreloadScheduler';

export function useImageReady(url: MaybeRefOrGetter<string>) {
  const readyUrls = getReadyUrls();
  return computed(() => readyUrls.value.has(toValue(url)));
}
